import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

// Concurrent-save conflict resolver (reconstructed — source not in kit).
// The backend's guarded update (updateEstimateGuarded) rejects with a
// 409 when the estimate changed since the dialog loaded; this dialog
// lets the user overwrite the server copy or discard their edits.
export default function ConcurrentSaveDialog({
  open,
  onOpenChange,
  detail,
  localPatch,
  serverEstimate,
  onOverwrite,
  onDiscard,
}) {
  const msg =
    (typeof detail === "object" && detail?.message) ||
    (typeof detail === "string" ? detail : null) ||
    "This estimate was changed somewhere else (another tab or device) after you opened it.";

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid="concurrent-save-dialog"
        className="bg-[#111] border-white/15 text-slate-100"
      >
        <AlertDialogHeader>
          <AlertDialogTitle>Save conflict</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">
            {msg} You can overwrite the newer version with your changes, or
            discard your changes and keep theirs.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            data-testid="concurrent-save-discard"
            onClick={onDiscard}
            className="bg-transparent border-white/15 text-slate-300 hover:bg-white/5"
          >
            Discard my changes
          </AlertDialogCancel>
          <Button
            data-testid="concurrent-save-overwrite"
            onClick={onOverwrite}
            className="bg-red-600 hover:bg-red-700 text-white font-semibold"
          >
            Overwrite with mine
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
